import EA from '../helpers/init';

export default EA.Methods.accordionHandler = ($this) => {
    const button = $this.querySelector('.accordion-header');
    const panel = $this.querySelector('.accordion-panel');
    const panelInner = panel.querySelector('.accordion-panel-inner');

    const toggle = () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';

        if (!expanded) {
            const allAccordions = $this.parentElement.querySelectorAll('.accordion');

            allAccordions.forEach((acc) => {
                if (acc === $this) return;

                const accButton = acc.querySelector('.accordion-header');
                const accPanel  = acc.querySelector('.accordion-panel');

                acc.classList.remove('active');
                if (accButton) accButton.setAttribute('aria-expanded', 'false');
                if (accPanel) accPanel.hidden = true;
            });
        }

        $this.classList.toggle('active', !expanded);
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
    };

    $this.addEventListener('click', (e) => {
        console.log(e.target);
        
        if(panelInner.contains(e.target)) return;

        toggle(); 
    });
};
